import { render, staticRenderFns } from "./starred_projects_tab.vue?vue&type=template&id=32644540"
import script from "./starred_projects_tab.vue?vue&type=script&lang=js"
export * from "./starred_projects_tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports